import { createFileRoute, notFound } from "@tanstack/react-router";
import NotFound from "@/components/blocks/not-found";
import { generateSeo } from "@/lib/utils/seo";
import {
	getServiceBySlug,
	ServiceNotFoundError,
} from "@/lib/utils/services.utils";

export const Route = createFileRoute("/services/$slug")({
	loader: async ({ params }) => {
		try {
			const service = await getServiceBySlug(params.slug);
			return { isValid: true, slug: params.slug, service, faqs: service.faqs };
		} catch (error) {
			if (error instanceof ServiceNotFoundError) {
				throw notFound();
			}
			throw error;
		}
	},
	notFoundComponent: NotFound,
	head: ({ loaderData }) => {
		if (!loaderData?.isValid || !loaderData?.service) {
			return {
				meta: [{ title: "Service Not Found | CraftLayer" }],
			};
		}
		const { service } = loaderData;
		return generateSeo({
			title: `${service.label} | CraftLayer`,
			description: service.description,
			url: service.href,
			keywords: service.keywords,
		});
	},
});
